module.exports = __webpack_public_path__ + "static/media/usdtt.fc400e03.jpeg";